import React, { useEffect, useState } from "react";
import { ChatCircleText, Fire } from "@phosphor-icons/react";
import { api } from "../lib/api";
import { advisorHeaders } from "../lib/clarity";

export default function ProfileCheckins({ email }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    setD(null);
    api.get(`/admin/profile/${encodeURIComponent(email)}/checkins`, advisorHeaders()).then((r) => setD(r.data)).catch(() => setD({ checkins: [], error: true }));
  }, [email]);
  if (!d) return null;
  const answered = d.checkins.filter((c) => c.response);

  return (
    <div data-testid="profile-checkins" className="card-surface p-6">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <p className="eyebrow text-xs flex items-center gap-2"><ChatCircleText size={14} /> Check-ins · call prep</p>
        {d.streak && (
          <p data-testid="profile-checkins-streak" className="text-xs text-exodus-muted flex items-center gap-2">
            <Fire size={14} className="text-orange-400" weight="fill" /> Current {d.streak.current} · Best {d.streak.best} · Total {d.streak.total}
            {d.rewards?.playbook_unlocked && " · Playbook unlocked"}{d.rewards?.free_booking_used ? " · Free review redeemed" : d.rewards?.free_booking_unlocked ? " · Free review unlocked" : ""}
            {d.reminders_off && " · Reminders off"}
          </p>
        )}
      </div>
      {d.checkins.length === 0 ? (
        <p className="text-sm text-exodus-muted mt-4">{d.error ? "Could not load check-ins." : "No check-ins yet."}</p>
      ) : (
        <>
          {answered.length > 0 && (
            <div data-testid="profile-checkins-recent" className="mt-4 border-l-2 border-exodus-gold pl-4 space-y-2">
              <p className="text-[10px] uppercase tracking-widest text-exodus-muted">Recent check-in answers</p>
              {answered.slice(0, 3).map((c) => <p key={c.period} className="text-sm italic">“{c.response}”</p>)}
            </div>
          )}
          <div className="mt-5 space-y-4 max-h-96 overflow-y-auto pr-2">
            {d.checkins.map((c) => (
              <div key={c.period} data-testid={`profile-checkin-${c.period}`} className="border-t border-exodus-border pt-3 text-sm">
                <p className="text-[11px] text-exodus-muted">{c.at ? new Date(c.at).toLocaleString() : "—"} · {c.episode}</p>
                <p className="mt-1 text-exodus-text/90">{c.question}</p>
                <p className={`mt-1 ${c.response ? "gold-text" : "text-exodus-muted text-xs"}`}>{c.response || "No written answer"}</p>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
